export const updateFoldClass = ({ location, params }) => {
  const { pathname } = location;
  let l;
  if (pathname === '/' || pathname === '/ar' || pathname === '/ar/') {
    l = 'front';
  } else {
    const matchNumber = location.pathname.match(/(\w+)/g)[0] === 'ar' ? 1 : 0;
    l = pathname.match(/(\w+)/g)[matchNumber];
  }
  switch (l) {
    case 'front':
      return 'on-landing';
    case 'workshops':
    case 'facilitators':
    case 'participants':
    case 'projects':
      return typeof params.id !== 'undefined' ? 'on-inner' : 'on-index';
    default:
      return 'on-inner';
  }
};

export const isFront = (path) => {
  if (path === '/' || path === '/ar' || path === '/ar/') {
    return true;
  }
  return false;
};

export const closeHighlights = () => {
  if (document.body.classList.contains('highlightsVisible')) {
    document.body.classList.remove('highlightsVisible');
  }
};

export const resetFoldScrollPosition = (el) => {
  const fold = document.querySelector(el);
  if (fold) fold.scrollTop = 0;
};

export const getContentImage = (imgUrl) => {
  const windowWidth = window.innerWidth;
  if (windowWidth > 1200) {
    return imgUrl;
  } else if (windowWidth > 1020) {
    return imgUrl.replace(/original/, 'w600');
  }
  return imgUrl.replace(/original/, 'w400'); // mobile
};

export const getIndexImage = (imgUrl, onIndex) => {
  const windowWidth = window.innerWidth;
  if (onIndex) {
    if (windowWidth > 1920) {
      return imgUrl;
    } else if (windowWidth > 1020) {
      return imgUrl.replace(/original/, 'w600');
    }
    return imgUrl.replace(/original/, 'w400'); // mobile
  }
  if (windowWidth > 720) {
    return imgUrl.replace(/original/, 'w200');
  }
  return imgUrl.replace(/original/, 'w400');
};

export const formatDate = eventDate => eventDate.split('-').reverse().join('.');



// WEBPACK FOOTER //
// ./js/ui-helpers.js